export enum SideToShowOption {
  OnlyLeft = 'ONLY_LEFT',
  OnlyRight = 'ONLY_RIGHT',
  LeftAndRight = 'LEFT_AND_RIGHT',
  None = 'NONE',
}
